import React, { ButtonHTMLAttributes, FC } from 'react';
import styled from '@xstyled/styled-components';
import Icon from '~/assets/icons/chevron.svg';
import { t } from 'ttag';

const OvalButton = styled.button`
  width: 30px;
  height: 68px;
  border-radius: 15px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  overflow: visible;
  background: ${p => p.theme.colors.overlayMed};
  position: relative;
  padding-bottom: 6px;
  margin: 0 6px;
`;

const RoundButton = styled.div`
  background: ${p => p.theme.colors.accentDark};
  width: 42px;
  height: 42px;
  border-radius: 21px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.colors.white};
  position: absolute;
  top: 0px;
  left: -6px;
  font-weight: bold;
`;

const StyledIcon = styled(Icon)`
  width: 12px;
  transform: rotate(90deg);
  transform-origin: center;
  stroke: ${p => p.theme.colors.white};
`;

export const NavigationButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...props
}) => (
  <OvalButton {...props} aria-label={t`Menu`} title={t`Menu`}>
    <RoundButton>{children}</RoundButton>
    <StyledIcon />
  </OvalButton>
);
